import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import { AuthorizationGate } from './components/Authorization'
import { Browser, Send } from './components/yaps'

const layoutStyle = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column'
}

const contentStyle = {
  width: '100%',
  maxWidth: '600px',
  margin: '0 auto',
  padding: '8px'
}

export const YapsHome = () => {
  const auth = useSelector((state) => state.auth)
  const config = useSelector((state) => state.config)
  const yaps = useSelector((state) => state.yaps)
  const navigation = useSelector((state) => state.navigation)
  const language = useSelector((state) => state.language)
  const error = useSelector((state) => state.error)

  const sendProps = {
    auth,
    creating: yaps.creating,
    created: yaps.created,
    createDisabled: yaps.createDisabled,
    validationError: yaps.validationError,
    draftedMessage: yaps.draftedMessage,
    error,
    language: language.active,
    navigation,
    ...config
  }

  return (
    <AuthorizationGate>
      <Box sx={layoutStyle}>
        <Send {...sendProps} />
        <Box sx={contentStyle}>
          <Browser {...yaps} {...navigation} />
        </Box>
      </Box>
    </AuthorizationGate>
  )
}
